/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoVehicleBasicBaseResponse as LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse } from '../../models/Limelight/Babylon/DataObjects/DTO/dto-vehicle-basic-base-response';

export interface V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml$Params {
  plateVin?: string;
  applicationId: string;
}

export function v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml(http: HttpClient, rootUrl: string, params: V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml.PATH, 'get');
  if (params) {
    rb.query('plateVin', params.plateVin, {});
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>;
    })
  );
}

v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml.PATH = '/v4/public/application/vehicle/{applicationId}/vehicleLookup';
